import { useAuthContext } from '../contexts/AuthContext';
export function useAuth() {
    const authContext = useAuthContext();
    return {
        // Auth state
        user: authContext.user,
        isAuthenticated: authContext.isAuthenticated,
        isLoading: authContext.isLoading,
        // Auth actions
        login: authContext.login,
        logout: authContext.logout,
        updateUser: authContext.updateUser,
    };
}
